import * as React from "react";
const SvgCamera = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 31 23",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "M30.407 8.03v8.918a5.613 5.613 0 0 1-5.615 5.616H5.615A5.615 5.615 0 0 1 0 16.948V8.03a5.62 5.62 0 0 1 5.615-5.617H9.17C9.17 1.079 11.844 0 15.144 0s5.972 1.08 5.972 2.413h3.676a5.616 5.616 0 0 1 5.615 5.617"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#fff",
	d: "M15.051 6.364a6.06 6.06 0 1 0 0 12.12 6.06 6.06 0 0 0 0-12.12m0 10.256a4.196 4.196 0 1 1 3.878-2.588 4.2 4.2 0 0 1-3.878 2.595z"
}));
export default SvgCamera;
